import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
export default {
  props: ['eventId'],
  mixins: [loadMoreList],
  data: function data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      paramsData: {
        // page: 1,
        name: '',
        account: ''
      },
      reward_tier_id: '',
      student_ids: [],
      rewardList: []
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getList(1);

              case 2:
                _context.next = 4;
                return _this.getTierList();

              case 4:
                if (data) {}

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.student_ids = e;
    },
    getTierList: function getTierList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var page;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;

                _this2.$api.rewardTierList({
                  reward_group_id: sessionStorage.getItem('rewardGroupID')
                }).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    _this2.rewardList = data;
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getList: function getList(page) {
      var _this3 = this;

      // this.paramsData.page = page;
      if (this.paramsData.account) {
        this.paramsData.appid = process.env.VUE_APP_APPID;
      }

      this.$api.eventParticipantVip(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        event_id: this.eventId,
        designate: true
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          _this3.tableData = data; // this.total = res.data.total
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      if (!this.reward_tier_id) {
        this.$message.error('请选择奖励分组');
        return;
      }

      var ids = this.student_ids.map(function (item) {
        return item.id;
      });
      this.$api.designatedWinnerAdd({
        student_ids: ids,
        event_id: this.eventId,
        reward_tier_id: this.reward_tier_id
      }).then(function (res) {
        if (res.code == 200) {
          _this4.$message.success('添加成功');

          _this4.$emit('change');

          _this4.dialogFormVisible = false;
        } else {
          _this4.$message.error(res.msg);
        }
      });
    }
  }
};